import * as React from "react";
import { useContext } from "react";
import styled, { css } from "styled-components";
import { FormGroupControlIdContext } from "./FormGroup";
const StyledLabel = styled.label(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
    font-weight: bold;
    margin-bottom: 5px;
    display: inline-block;
  `
);
const ControlLabel = ({ children, className = void 0, htmlFor = void 0, style = void 0 }) => {
  const controlId = useContext(FormGroupControlIdContext);
  return /* @__PURE__ */ React.createElement(StyledLabel, { htmlFor: htmlFor != null ? htmlFor : controlId, className: `${className != null ? className : ""} control-label`, style }, children);
};
export default ControlLabel;
